import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectPartner } from "../store/partnerStore";
import { PARTNER_KEYS } from "../utils/partner";

const themes = {
  [PARTNER_KEYS.CLALIT]: {
    "--primary-color": "#1B296B",
    "--primary-color-border": "#1B296B",
    "--primary-color-footer": "#97d4f7",
    "--primary-color-footer-text": "#1B296B",
    "--sidebar-color-text": "#FFFFFF",
    "--order-again-button": "#1B296B",
    "--darkblue": "#1B296B",
    "--blue-text-color": "#139deb",
    "--red-text-color": "#D23240",
    "--red-button-color": "#D23240",
    "--red-button-text-color": "#FFFFFF",
    "--dropdown-menu-background": "#1B296B",
    "--dropdown-menu-border": "#1B296B",
    "--dropdown-menu-color": "#FFFFFF",
    "--club-card-background-color": "#F4F9FC",
    "--club-card-price-color": "#139deb",
    "--dropdown-background-color": "#F4F9FC",
    "--dropdown-border-color": "#1B296B",
    "--history-background-color": "#f4f9fc",
    "--scheduled-button-text-color": "#1B296B",
    "--available-room-color": "#f69934",
    "--coach-name-color": "#959594",
    "--dialog-border-radius": "0",
    "--font-family": `"OpenSans", sans-serif`,
  },
  [PARTNER_KEYS.MEHUDET]: {
    "--primary-color": "#009BDF",
    "--primary-color-border": "#0091EA",
    "--primary-color-footer": "#F3F9FE",
    "--primary-color-footer-text": "#FFFFFF",
    "--sidebar-color-text": "#003D62",
    "--order-again-button": "#003D62",
    "--darkblue": "#003D62",
    "--blue-text-color": "#003D62",
    "--red-text-color": "#003D62",
    "--red-button-color": "#CFECFF",
    "--red-button-text-color": "#153899",
    "--dropdown-menu-background": "#F3F9FE",
    "--dropdown-menu-border": "#F0F1F2",
    "--dropdown-menu-color": "#003D62",
    "--club-card-background-color": "#FFFFFF",
    "--club-card-price-color": "#0091EA",
    "--dropdown-background-color": "#FFFFFF",
    "--dropdown-border-color": "#D8D8D8",
    "--history-background-color": "#ffffff",
    "--scheduled-button-text-color": "#153899",
    "--available-room-color": "#0067A6",
    "--coach-name-color": "#003D62",
    "--dialog-border-radius": "24px",
    "--font-family": `Ploni ML v2 AAA`,
  },
  [PARTNER_KEYS.OVDIM_BARI]: {
    "--primary-color": "#3946C0",
    "--primary-color-border": "#3946C0",
    "--primary-color-footer": "#3946C0",
    "--primary-color-footer-text": "#FFFFFF",
    "--sidebar-color-text": "#FFFFFF",
    "--order-again-button": "#3946C0",
    "--darkblue": "#3946C0",
    "--blue-text-color": "#3946C0",
    "--red-text-color": "#D23240",
    "--red-button-color": "#D23240",
    "--red-button-text-color": "#FFFFFF",
    "--dropdown-menu-background": "#3946C0",
    "--dropdown-menu-border": "#3946C0",
    "--dropdown-menu-color": "#FFFFFF",
    "--club-card-background-color": "#F4F9FC",
    "--club-card-price-color": "#3946C0",
    "--dropdown-background-color": "#F4F9FC",
    "--dropdown-border-color": "#3946C0",
    "--history-background-color": "#F4F9FC",
    "--scheduled-button-text-color": "#3946C0",
    "--available-room-color": "#f69934",
    "--coach-name-color": "#959594",
    "--dialog-border-radius": "0",
    "--font-family": `"OpenSans", sans-serif`,
  },
};

const ThemeProvider = ({ children }) => {
  const partner = useSelector(selectPartner);

  useEffect(() => {
    const theme = themes[partner] || themes[PARTNER_KEYS.MEHUDET];

    Object.entries(theme).forEach(([property, value]) => {
      document.documentElement.style.setProperty(property, value);
    });
  }, [partner]);

  return <>{children}</>;
};

export default ThemeProvider;
